import * as React from "react";
import LinkJuiceCategorySection from "./LinkJuiceCategorySection";
import { LinkJuiceProps } from "./typings";
import { InsideTabGroupContext } from "components/shared/InsideTabGroupContext/InsideTabGroupContext";
import { UitkHeading } from "uitk-react-text";

export function LinkJuice(props: LinkJuiceProps) {
  const { flexComponent } = props;
  const { model } = flexComponent;
  const { title, categories, collapsed, displayColumns } = model;

  if (!(title && categories && categories.length)) {
    return null;
  }

  const insideTabGroup = React.useContext(InsideTabGroupContext);
  const paddingTopClassName = insideTabGroup ? "" : " all-t-padding-three";

  return (
    <div
      className={`LinkJuice all-cell-1-1 uitk-cell${paddingTopClassName}`}
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      {!insideTabGroup && (
        <div className="all-y-padding-three">
          <UitkHeading level={2} size={600}>
            {title}
          </UitkHeading>
        </div>
      )}
      {categories.map(
        (category) =>
          category.name && (
            <LinkJuiceCategorySection
              key={category.name}
              category={category}
              collapsed={collapsed || false}
              displayColumns={displayColumns}
            />
          )
      )}
    </div>
  );
}

export default LinkJuice;
